export const FetchErrorHandle = (error: any): void => {
       if (error.response._data?.error?.statusCode === 401) {
             navigateTo('/login'); 
       }
};